import React from "react";
import BackToTop from "~/components/qol/BackToTop";
import NavbarLayout from "~/src/components/navbar/NavbarLayout";
import ProjectsListingPage from "~/src/components/project/pages/ProjectsListingPage";

export default function ProjectsPage() {
  return (
    <NavbarLayout>
      <ProjectsListingPage />
      <BackToTop />
    </NavbarLayout>
  );
}
